/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthMfaRouteImport } from './routes/_auth.mfa'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AutomationsIndexRouteImport } from './routes/automations.index'
import { Route as AutomationsIdRouteImport } from './routes/automations.$id'
import { Route as AutomationsNewRouteImport } from './routes/automations.new'
import { Route as BillsIndexRouteImport } from './routes/bills.index'
import { Route as BillsRefRouteImport } from './routes/bills.$ref'
import { Route as BillsNewRouteImport } from './routes/bills.new'
import { Route as CommunicationsIndexRouteImport } from './routes/communications.index'
import { Route as ContractorsIndexRouteImport } from './routes/contractors.index'
import { Route as ContractorsRefRouteImport } from './routes/contractors.$ref'
import { Route as DashboardCustomRouteImport } from './routes/dashboard.custom'
import { Route as DashboardManagementRouteImport } from './routes/dashboard.management'
import { Route as FinancialIndexRouteImport } from './routes/financial.index'
import { Route as FinancialCommissionRouteImport } from './routes/financial.commission'
import { Route as FinancialEntryRouteImport } from './routes/financial.entry'
import { Route as FinancialNewRouteImport } from './routes/financial.new'
import { Route as FinancialTransactionsRouteImport } from './routes/financial.transactions'
import { Route as MaintenanceIndexRouteImport } from './routes/maintenance.index'
import { Route as MaintenanceRefRouteImport } from './routes/maintenance.$ref'
import { Route as MaintenanceNewRouteImport } from './routes/maintenance.new'
import { Route as OwnersIndexRouteImport } from './routes/owners.index'
import { Route as OwnersRefRouteImport } from './routes/owners.$ref'
import { Route as OwnersNewRouteImport } from './routes/owners.new'
import { Route as PeopleIndexRouteImport } from './routes/people.index'
import { Route as PeopleRefRouteImport } from './routes/people.$ref'
import { Route as PeopleNewRouteImport } from './routes/people.new'
import { Route as PeoplePortalRouteImport } from './routes/people.portal'
import { Route as PropertiesIndexRouteImport } from './routes/properties.index'
import { Route as PropertiesRefRouteImport } from './routes/properties.$ref'
import { Route as PropertiesListingsRouteImport } from './routes/properties.listings'
import { Route as PropertiesMapRouteImport } from './routes/properties.map'
import { Route as PropertiesNewRouteImport } from './routes/properties.new'
import { Route as ReconcileIndexRouteImport } from './routes/reconcile.index'
import { Route as ReconcileImportRouteImport } from './routes/reconcile.import'
import { Route as ReconcileQueueRouteImport } from './routes/reconcile.queue'
import { Route as ReconcileSuspenseRouteImport } from './routes/reconcile.suspense'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsAuditRouteImport } from './routes/reports.audit'
import { Route as ReportsDeliveryRouteImport } from './routes/reports.delivery'
import { Route as ReportsEventsRouteImport } from './routes/reports.events'
import { Route as ReportsHealthyHomesRouteImport } from './routes/reports.healthy-homes'
import { Route as ReportsMatchingRouteImport } from './routes/reports.matching'
import { Route as ReportsReconciliationRouteImport } from './routes/reports.reconciliation'
import { Route as ReportsRefundsRouteImport } from './routes/reports.refunds'
import { Route as ReportsStatementsRouteImport } from './routes/reports.statements'
import { Route as ReportsTaxRouteImport } from './routes/reports.tax'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsBrandingRouteImport } from './routes/settings.branding'
import { Route as SettingsDeliveryRouteImport } from './routes/settings.delivery'
import { Route as SettingsImportRouteImport } from './routes/settings.import'
import { Route as SettingsInspectionsRouteImport } from './routes/settings.inspections'
import { Route as SettingsOpeningBalancesRouteImport } from './routes/settings.opening-balances'
import { Route as SettingsParallelRunRouteImport } from './routes/settings.parallel-run'
import { Route as SettingsPaymentsRouteImport } from './routes/settings.payments'
import { Route as SettingsStatementsRouteImport } from './routes/settings.statements'
import { Route as SettingsTaxRouteImport } from './routes/settings.tax'
import { Route as SettingsTemplatesRouteImport } from './routes/settings.templates'
import { Route as SettingsUnitCostsRouteImport } from './routes/settings.unit-costs'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'
import { Route as TenanciesIndexRouteImport } from './routes/tenancies.index'
import { Route as TenanciesRefRouteImport } from './routes/tenancies.$ref'
import { Route as TenanciesArrearsRouteImport } from './routes/tenancies.arrears'
import { Route as TenanciesBondsRouteImport } from './routes/tenancies.bonds'
import { Route as TenanciesNewRouteImport } from './routes/tenancies.new'
import { Route as TenanciesRentReviewsRouteImport } from './routes/tenancies.rent-reviews'
import { Route as BillsInvoicesIndexRouteImport } from './routes/bills.invoices.index'
import { Route as BillsInvoicesRefRouteImport } from './routes/bills.invoices.$ref'
import { Route as BillsInvoicesNewRouteImport } from './routes/bills.invoices.new'
import { Route as CommunicationsInboxIndexRouteImport } from './routes/communications.inbox.index'
import { Route as CommunicationsInboxIdRouteImport } from './routes/communications.inbox.$id'
import { Route as CommunicationsListsIdRouteImport } from './routes/communications.lists.$id'
import { Route as CommunicationsListsNewRouteImport } from './routes/communications.lists.new'
import { Route as CommunicationsSendsIndexRouteImport } from './routes/communications.sends.index'
import { Route as CommunicationsSendsIdRouteImport } from './routes/communications.sends.$id'
import { Route as FinancialDisbursementsIndexRouteImport } from './routes/financial.disbursements.index'
import { Route as FinancialDisbursementsRefRouteImport } from './routes/financial.disbursements.$ref'
import { Route as FinancialInvoicesIndexRouteImport } from './routes/financial.invoices.index'
import { Route as FinancialInvoicesRefRouteImport } from './routes/financial.invoices.$ref'
import { Route as FinancialInvoicesNewRouteImport } from './routes/financial.invoices.new'
import { Route as MaintenanceContractorsIndexRouteImport } from './routes/maintenance.contractors.index'
import { Route as MaintenanceContractorsRefRouteImport } from './routes/maintenance.contractors.$ref'
import { Route as MaintenanceContractorsNewRouteImport } from './routes/maintenance.contractors.new'
import { Route as PeopleRefIndexRouteImport } from './routes/people.$ref.index'
import { Route as PeopleRefEditRouteImport } from './routes/people.$ref.edit'
import { Route as PropertiesRefIndexRouteImport } from './routes/properties.$ref.index'
import { Route as PropertiesRefEditRouteImport } from './routes/properties.$ref.edit'
import { Route as PropertiesInspectionsIndexRouteImport } from './routes/properties.inspections.index'
import { Route as PropertiesInspectionsRefRouteImport } from './routes/properties.inspections.$ref'
import { Route as SettingsIntegrationsIndexRouteImport } from './routes/settings.integrations.index'
import { Route as SettingsOrganisationsIndexRouteImport } from './routes/settings.organisations.index'
import { Route as SettingsOrganisationsNewRouteImport } from './routes/settings.organisations.new'
import { Route as SettingsIntegrationsTenancyServicesCallbackRouteImport } from './routes/settings.integrations.tenancy-services.callback'
import { Route as SettingsIntegrationsTrademeCallbackRouteImport } from './routes/settings.integrations.trademe.callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaRoute = AuthMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AutomationsIndexRoute = AutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsIdRoute = AutomationsIdRouteImport.update({
  id: '/automations/$id',
  path: '/automations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsNewRoute = AutomationsNewRouteImport.update({
  id: '/automations/new',
  path: '/automations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsIndexRoute = BillsIndexRouteImport.update({
  id: '/bills/',
  path: '/bills/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsRefRoute = BillsRefRouteImport.update({
  id: '/bills/$ref',
  path: '/bills/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsNewRoute = BillsNewRouteImport.update({
  id: '/bills/new',
  path: '/bills/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsIndexRoute = CommunicationsIndexRouteImport.update({
  id: '/communications/',
  path: '/communications/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsIndexRoute = ContractorsIndexRouteImport.update({
  id: '/contractors/',
  path: '/contractors/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractorsRefRoute = ContractorsRefRouteImport.update({
  id: '/contractors/$ref',
  path: '/contractors/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardCustomRoute = DashboardCustomRouteImport.update({
  id: '/dashboard/custom',
  path: '/dashboard/custom',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardManagementRoute = DashboardManagementRouteImport.update({
  id: '/dashboard/management',
  path: '/dashboard/management',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialIndexRoute = FinancialIndexRouteImport.update({
  id: '/financial/',
  path: '/financial/',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialCommissionRoute = FinancialCommissionRouteImport.update({
  id: '/financial/commission',
  path: '/financial/commission',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialEntryRoute = FinancialEntryRouteImport.update({
  id: '/financial/entry',
  path: '/financial/entry',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialNewRoute = FinancialNewRouteImport.update({
  id: '/financial/new',
  path: '/financial/new',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialTransactionsRoute = FinancialTransactionsRouteImport.update({
  id: '/financial/transactions',
  path: '/financial/transactions',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceIndexRoute = MaintenanceIndexRouteImport.update({
  id: '/maintenance/',
  path: '/maintenance/',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceRefRoute = MaintenanceRefRouteImport.update({
  id: '/maintenance/$ref',
  path: '/maintenance/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceNewRoute = MaintenanceNewRouteImport.update({
  id: '/maintenance/new',
  path: '/maintenance/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnersIndexRoute = OwnersIndexRouteImport.update({
  id: '/owners/',
  path: '/owners/',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnersRefRoute = OwnersRefRouteImport.update({
  id: '/owners/$ref',
  path: '/owners/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnersNewRoute = OwnersNewRouteImport.update({
  id: '/owners/new',
  path: '/owners/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleRefRoute = PeopleRefRouteImport.update({
  id: '/people/$ref',
  path: '/people/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleNewRoute = PeopleNewRouteImport.update({
  id: '/people/new',
  path: '/people/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PeoplePortalRoute = PeoplePortalRouteImport.update({
  id: '/people/portal',
  path: '/people/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesIndexRoute = PropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesRefRoute = PropertiesRefRouteImport.update({
  id: '/properties/$ref',
  path: '/properties/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesListingsRoute = PropertiesListingsRouteImport.update({
  id: '/properties/listings',
  path: '/properties/listings',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesMapRoute = PropertiesMapRouteImport.update({
  id: '/properties/map',
  path: '/properties/map',
  getParentRoute: () => rootRouteImport,
} as any)
const PropertiesNewRoute = PropertiesNewRouteImport.update({
  id: '/properties/new',
  path: '/properties/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileIndexRoute = ReconcileIndexRouteImport.update({
  id: '/reconcile/',
  path: '/reconcile/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileImportRoute = ReconcileImportRouteImport.update({
  id: '/reconcile/import',
  path: '/reconcile/import',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileQueueRoute = ReconcileQueueRouteImport.update({
  id: '/reconcile/queue',
  path: '/reconcile/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconcileSuspenseRoute = ReconcileSuspenseRouteImport.update({
  id: '/reconcile/suspense',
  path: '/reconcile/suspense',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsAuditRoute = ReportsAuditRouteImport.update({
  id: '/reports/audit',
  path: '/reports/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsDeliveryRoute = ReportsDeliveryRouteImport.update({
  id: '/reports/delivery',
  path: '/reports/delivery',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsEventsRoute = ReportsEventsRouteImport.update({
  id: '/reports/events',
  path: '/reports/events',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsHealthyHomesRoute = ReportsHealthyHomesRouteImport.update({
  id: '/reports/healthy-homes',
  path: '/reports/healthy-homes',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsMatchingRoute = ReportsMatchingRouteImport.update({
  id: '/reports/matching',
  path: '/reports/matching',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsReconciliationRoute = ReportsReconciliationRouteImport.update({
  id: '/reports/reconciliation',
  path: '/reports/reconciliation',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRefundsRoute = ReportsRefundsRouteImport.update({
  id: '/reports/refunds',
  path: '/reports/refunds',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsStatementsRoute = ReportsStatementsRouteImport.update({
  id: '/reports/statements',
  path: '/reports/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsTaxRoute = ReportsTaxRouteImport.update({
  id: '/reports/tax',
  path: '/reports/tax',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsBrandingRoute = SettingsBrandingRouteImport.update({
  id: '/settings/branding',
  path: '/settings/branding',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsDeliveryRoute = SettingsDeliveryRouteImport.update({
  id: '/settings/delivery',
  path: '/settings/delivery',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsImportRoute = SettingsImportRouteImport.update({
  id: '/settings/import',
  path: '/settings/import',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsInspectionsRoute = SettingsInspectionsRouteImport.update({
  id: '/settings/inspections',
  path: '/settings/inspections',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsOpeningBalancesRoute = SettingsOpeningBalancesRouteImport.update({
  id: '/settings/opening-balances',
  path: '/settings/opening-balances',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsParallelRunRoute = SettingsParallelRunRouteImport.update({
  id: '/settings/parallel-run',
  path: '/settings/parallel-run',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPaymentsRoute = SettingsPaymentsRouteImport.update({
  id: '/settings/payments',
  path: '/settings/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStatementsRoute = SettingsStatementsRouteImport.update({
  id: '/settings/statements',
  path: '/settings/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTaxRoute = SettingsTaxRouteImport.update({
  id: '/settings/tax',
  path: '/settings/tax',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsTemplatesRoute = SettingsTemplatesRouteImport.update({
  id: '/settings/templates',
  path: '/settings/templates',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUnitCostsRoute = SettingsUnitCostsRouteImport.update({
  id: '/settings/unit-costs',
  path: '/settings/unit-costs',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesIndexRoute = TenanciesIndexRouteImport.update({
  id: '/tenancies/',
  path: '/tenancies/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesRefRoute = TenanciesRefRouteImport.update({
  id: '/tenancies/$ref',
  path: '/tenancies/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesArrearsRoute = TenanciesArrearsRouteImport.update({
  id: '/tenancies/arrears',
  path: '/tenancies/arrears',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesBondsRoute = TenanciesBondsRouteImport.update({
  id: '/tenancies/bonds',
  path: '/tenancies/bonds',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesNewRoute = TenanciesNewRouteImport.update({
  id: '/tenancies/new',
  path: '/tenancies/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TenanciesRentReviewsRoute = TenanciesRentReviewsRouteImport.update({
  id: '/tenancies/rent-reviews',
  path: '/tenancies/rent-reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsInvoicesIndexRoute = BillsInvoicesIndexRouteImport.update({
  id: '/bills/invoices/',
  path: '/bills/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsInvoicesRefRoute = BillsInvoicesRefRouteImport.update({
  id: '/bills/invoices/$ref',
  path: '/bills/invoices/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsInvoicesNewRoute = BillsInvoicesNewRouteImport.update({
  id: '/bills/invoices/new',
  path: '/bills/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsInboxIndexRoute =
  CommunicationsInboxIndexRouteImport.update({
    id: '/communications/inbox/',
    path: '/communications/inbox/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CommunicationsInboxIdRoute = CommunicationsInboxIdRouteImport.update({
  id: '/communications/inbox/$id',
  path: '/communications/inbox/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsListsIdRoute = CommunicationsListsIdRouteImport.update({
  id: '/communications/lists/$id',
  path: '/communications/lists/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsListsNewRoute = CommunicationsListsNewRouteImport.update({
  id: '/communications/lists/new',
  path: '/communications/lists/new',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsSendsIndexRoute =
  CommunicationsSendsIndexRouteImport.update({
    id: '/communications/sends/',
    path: '/communications/sends/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CommunicationsSendsIdRoute = CommunicationsSendsIdRouteImport.update({
  id: '/communications/sends/$id',
  path: '/communications/sends/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialDisbursementsIndexRoute =
  FinancialDisbursementsIndexRouteImport.update({
    id: '/financial/disbursements/',
    path: '/financial/disbursements/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FinancialDisbursementsRefRoute =
  FinancialDisbursementsRefRouteImport.update({
    id: '/financial/disbursements/$ref',
    path: '/financial/disbursements/$ref',
    getParentRoute: () => rootRouteImport,
  } as any)
const FinancialInvoicesIndexRoute = FinancialInvoicesIndexRouteImport.update({
  id: '/financial/invoices/',
  path: '/financial/invoices/',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialInvoicesRefRoute = FinancialInvoicesRefRouteImport.update({
  id: '/financial/invoices/$ref',
  path: '/financial/invoices/$ref',
  getParentRoute: () => rootRouteImport,
} as any)
const FinancialInvoicesNewRoute = FinancialInvoicesNewRouteImport.update({
  id: '/financial/invoices/new',
  path: '/financial/invoices/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MaintenanceContractorsIndexRoute =
  MaintenanceContractorsIndexRouteImport.update({
    id: '/maintenance/contractors/',
    path: '/maintenance/contractors/',
    getParentRoute: () => rootRouteImport,
  } as any)
const MaintenanceContractorsRefRoute =
  MaintenanceContractorsRefRouteImport.update({
    id: '/maintenance/contractors/$ref',
    path: '/maintenance/contractors/$ref',
    getParentRoute: () => rootRouteImport,
  } as any)
const MaintenanceContractorsNewRoute =
  MaintenanceContractorsNewRouteImport.update({
    id: '/maintenance/contractors/new',
    path: '/maintenance/contractors/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const PeopleRefIndexRoute = PeopleRefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PeopleRefRoute,
} as any)
const PeopleRefEditRoute = PeopleRefEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => PeopleRefRoute,
} as any)
const PropertiesRefIndexRoute = PropertiesRefIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PropertiesRefRoute,
} as any)
const PropertiesRefEditRoute = PropertiesRefEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => PropertiesRefRoute,
} as any)
const PropertiesInspectionsIndexRoute =
  PropertiesInspectionsIndexRouteImport.update({
    id: '/properties/inspections/',
    path: '/properties/inspections/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PropertiesInspectionsRefRoute =
  PropertiesInspectionsRefRouteImport.update({
    id: '/properties/inspections/$ref',
    path: '/properties/inspections/$ref',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsIntegrationsIndexRoute =
  SettingsIntegrationsIndexRouteImport.update({
    id: '/settings/integrations/',
    path: '/settings/integrations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsOrganisationsIndexRoute =
  SettingsOrganisationsIndexRouteImport.update({
    id: '/settings/organisations/',
    path: '/settings/organisations/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsOrganisationsNewRoute =
  SettingsOrganisationsNewRouteImport.update({
    id: '/settings/organisations/new',
    path: '/settings/organisations/new',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsIntegrationsTenancyServicesCallbackRoute =
  SettingsIntegrationsTenancyServicesCallbackRouteImport.update({
    id: '/settings/integrations/tenancy-services/callback',
    path: '/settings/integrations/tenancy-services/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsIntegrationsTrademeCallbackRoute =
  SettingsIntegrationsTrademeCallbackRouteImport.update({
    id: '/settings/integrations/trademe/callback',
    path: '/settings/integrations/trademe/callback',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/set-password': typeof SetPasswordRoute
  '/terms': typeof TermsRoute
  '/login': typeof AuthLoginRoute
  '/mfa': typeof AuthMfaRoute
  '/signup': typeof AuthSignupRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/automations/new': typeof AutomationsNewRoute
  '/bills/$ref': typeof BillsRefRoute
  '/bills/new': typeof BillsNewRoute
  '/contractors/$ref': typeof ContractorsRefRoute
  '/dashboard/custom': typeof DashboardCustomRoute
  '/dashboard/management': typeof DashboardManagementRoute
  '/financial/commission': typeof FinancialCommissionRoute
  '/financial/entry': typeof FinancialEntryRoute
  '/financial/new': typeof FinancialNewRoute
  '/financial/transactions': typeof FinancialTransactionsRoute
  '/maintenance/$ref': typeof MaintenanceRefRoute
  '/maintenance/new': typeof MaintenanceNewRoute
  '/owners/$ref': typeof OwnersRefRoute
  '/owners/new': typeof OwnersNewRoute
  '/people/$ref': typeof PeopleRefRouteWithChildren
  '/people/new': typeof PeopleNewRoute
  '/people/portal': typeof PeoplePortalRoute
  '/properties/$ref': typeof PropertiesRefRouteWithChildren
  '/properties/listings': typeof PropertiesListingsRoute
  '/properties/map': typeof PropertiesMapRoute
  '/properties/new': typeof PropertiesNewRoute
  '/reconcile/import': typeof ReconcileImportRoute
  '/reconcile/queue': typeof ReconcileQueueRoute
  '/reconcile/suspense': typeof ReconcileSuspenseRoute
  '/reports/audit': typeof ReportsAuditRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/events': typeof ReportsEventsRoute
  '/reports/healthy-homes': typeof ReportsHealthyHomesRoute
  '/reports/matching': typeof ReportsMatchingRoute
  '/reports/reconciliation': typeof ReportsReconciliationRoute
  '/reports/refunds': typeof ReportsRefundsRoute
  '/reports/statements': typeof ReportsStatementsRoute
  '/reports/tax': typeof ReportsTaxRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/inspections': typeof SettingsInspectionsRoute
  '/settings/opening-balances': typeof SettingsOpeningBalancesRoute
  '/settings/parallel-run': typeof SettingsParallelRunRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/statements': typeof SettingsStatementsRoute
  '/settings/tax': typeof SettingsTaxRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/unit-costs': typeof SettingsUnitCostsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tenancies/$ref': typeof TenanciesRefRoute
  '/tenancies/arrears': typeof TenanciesArrearsRoute
  '/tenancies/bonds': typeof TenanciesBondsRoute
  '/tenancies/new': typeof TenanciesNewRoute
  '/tenancies/rent-reviews': typeof TenanciesRentReviewsRoute
  '/automations/': typeof AutomationsIndexRoute
  '/bills/': typeof BillsIndexRoute
  '/communications/': typeof CommunicationsIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/financial/': typeof FinancialIndexRoute
  '/maintenance/': typeof MaintenanceIndexRoute
  '/owners/': typeof OwnersIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/properties/': typeof PropertiesIndexRoute
  '/reconcile/': typeof ReconcileIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tenancies/': typeof TenanciesIndexRoute
  '/bills/invoices/$ref': typeof BillsInvoicesRefRoute
  '/bills/invoices/new': typeof BillsInvoicesNewRoute
  '/communications/inbox/$id': typeof CommunicationsInboxIdRoute
  '/communications/lists/$id': typeof CommunicationsListsIdRoute
  '/communications/lists/new': typeof CommunicationsListsNewRoute
  '/communications/sends/$id': typeof CommunicationsSendsIdRoute
  '/financial/disbursements/$ref': typeof FinancialDisbursementsRefRoute
  '/financial/invoices/$ref': typeof FinancialInvoicesRefRoute
  '/financial/invoices/new': typeof FinancialInvoicesNewRoute
  '/maintenance/contractors/$ref': typeof MaintenanceContractorsRefRoute
  '/maintenance/contractors/new': typeof MaintenanceContractorsNewRoute
  '/people/$ref/edit': typeof PeopleRefEditRoute
  '/properties/$ref/edit': typeof PropertiesRefEditRoute
  '/properties/inspections/$ref': typeof PropertiesInspectionsRefRoute
  '/settings/organisations/new': typeof SettingsOrganisationsNewRoute
  '/bills/invoices/': typeof BillsInvoicesIndexRoute
  '/communications/inbox/': typeof CommunicationsInboxIndexRoute
  '/communications/sends/': typeof CommunicationsSendsIndexRoute
  '/financial/disbursements/': typeof FinancialDisbursementsIndexRoute
  '/financial/invoices/': typeof FinancialInvoicesIndexRoute
  '/maintenance/contractors/': typeof MaintenanceContractorsIndexRoute
  '/people/$ref/': typeof PeopleRefIndexRoute
  '/properties/$ref/': typeof PropertiesRefIndexRoute
  '/properties/inspections/': typeof PropertiesInspectionsIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/settings/organisations/': typeof SettingsOrganisationsIndexRoute
  '/settings/integrations/tenancy-services/callback': typeof SettingsIntegrationsTenancyServicesCallbackRoute
  '/settings/integrations/trademe/callback': typeof SettingsIntegrationsTrademeCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/privacy': typeof PrivacyRoute
  '/set-password': typeof SetPasswordRoute
  '/terms': typeof TermsRoute
  '/login': typeof AuthLoginRoute
  '/mfa': typeof AuthMfaRoute
  '/signup': typeof AuthSignupRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/automations/new': typeof AutomationsNewRoute
  '/bills/$ref': typeof BillsRefRoute
  '/bills/new': typeof BillsNewRoute
  '/contractors/$ref': typeof ContractorsRefRoute
  '/dashboard/custom': typeof DashboardCustomRoute
  '/dashboard/management': typeof DashboardManagementRoute
  '/financial/commission': typeof FinancialCommissionRoute
  '/financial/entry': typeof FinancialEntryRoute
  '/financial/new': typeof FinancialNewRoute
  '/financial/transactions': typeof FinancialTransactionsRoute
  '/maintenance/$ref': typeof MaintenanceRefRoute
  '/maintenance/new': typeof MaintenanceNewRoute
  '/owners/$ref': typeof OwnersRefRoute
  '/owners/new': typeof OwnersNewRoute
  '/people/new': typeof PeopleNewRoute
  '/people/portal': typeof PeoplePortalRoute
  '/properties/listings': typeof PropertiesListingsRoute
  '/properties/map': typeof PropertiesMapRoute
  '/properties/new': typeof PropertiesNewRoute
  '/reconcile/import': typeof ReconcileImportRoute
  '/reconcile/queue': typeof ReconcileQueueRoute
  '/reconcile/suspense': typeof ReconcileSuspenseRoute
  '/reports/audit': typeof ReportsAuditRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/events': typeof ReportsEventsRoute
  '/reports/healthy-homes': typeof ReportsHealthyHomesRoute
  '/reports/matching': typeof ReportsMatchingRoute
  '/reports/reconciliation': typeof ReportsReconciliationRoute
  '/reports/refunds': typeof ReportsRefundsRoute
  '/reports/statements': typeof ReportsStatementsRoute
  '/reports/tax': typeof ReportsTaxRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/inspections': typeof SettingsInspectionsRoute
  '/settings/opening-balances': typeof SettingsOpeningBalancesRoute
  '/settings/parallel-run': typeof SettingsParallelRunRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/statements': typeof SettingsStatementsRoute
  '/settings/tax': typeof SettingsTaxRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/unit-costs': typeof SettingsUnitCostsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tenancies/$ref': typeof TenanciesRefRoute
  '/tenancies/arrears': typeof TenanciesArrearsRoute
  '/tenancies/bonds': typeof TenanciesBondsRoute
  '/tenancies/new': typeof TenanciesNewRoute
  '/tenancies/rent-reviews': typeof TenanciesRentReviewsRoute
  '/automations': typeof AutomationsIndexRoute
  '/bills': typeof BillsIndexRoute
  '/communications': typeof CommunicationsIndexRoute
  '/contractors': typeof ContractorsIndexRoute
  '/financial': typeof FinancialIndexRoute
  '/maintenance': typeof MaintenanceIndexRoute
  '/owners': typeof OwnersIndexRoute
  '/people': typeof PeopleIndexRoute
  '/properties': typeof PropertiesIndexRoute
  '/reconcile': typeof ReconcileIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tenancies': typeof TenanciesIndexRoute
  '/bills/invoices/$ref': typeof BillsInvoicesRefRoute
  '/bills/invoices/new': typeof BillsInvoicesNewRoute
  '/communications/inbox/$id': typeof CommunicationsInboxIdRoute
  '/communications/lists/$id': typeof CommunicationsListsIdRoute
  '/communications/lists/new': typeof CommunicationsListsNewRoute
  '/communications/sends/$id': typeof CommunicationsSendsIdRoute
  '/financial/disbursements/$ref': typeof FinancialDisbursementsRefRoute
  '/financial/invoices/$ref': typeof FinancialInvoicesRefRoute
  '/financial/invoices/new': typeof FinancialInvoicesNewRoute
  '/maintenance/contractors/$ref': typeof MaintenanceContractorsRefRoute
  '/maintenance/contractors/new': typeof MaintenanceContractorsNewRoute
  '/people/$ref/edit': typeof PeopleRefEditRoute
  '/properties/$ref/edit': typeof PropertiesRefEditRoute
  '/properties/inspections/$ref': typeof PropertiesInspectionsRefRoute
  '/settings/organisations/new': typeof SettingsOrganisationsNewRoute
  '/bills/invoices': typeof BillsInvoicesIndexRoute
  '/communications/inbox': typeof CommunicationsInboxIndexRoute
  '/communications/sends': typeof CommunicationsSendsIndexRoute
  '/financial/disbursements': typeof FinancialDisbursementsIndexRoute
  '/financial/invoices': typeof FinancialInvoicesIndexRoute
  '/maintenance/contractors': typeof MaintenanceContractorsIndexRoute
  '/people/$ref': typeof PeopleRefIndexRoute
  '/properties/$ref': typeof PropertiesRefIndexRoute
  '/properties/inspections': typeof PropertiesInspectionsIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/settings/organisations': typeof SettingsOrganisationsIndexRoute
  '/settings/integrations/tenancy-services/callback': typeof SettingsIntegrationsTenancyServicesCallbackRoute
  '/settings/integrations/trademe/callback': typeof SettingsIntegrationsTrademeCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/set-password': typeof SetPasswordRoute
  '/terms': typeof TermsRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/mfa': typeof AuthMfaRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/automations/$id': typeof AutomationsIdRoute
  '/automations/new': typeof AutomationsNewRoute
  '/bills/$ref': typeof BillsRefRoute
  '/bills/new': typeof BillsNewRoute
  '/contractors/$ref': typeof ContractorsRefRoute
  '/dashboard/custom': typeof DashboardCustomRoute
  '/dashboard/management': typeof DashboardManagementRoute
  '/financial/commission': typeof FinancialCommissionRoute
  '/financial/entry': typeof FinancialEntryRoute
  '/financial/new': typeof FinancialNewRoute
  '/financial/transactions': typeof FinancialTransactionsRoute
  '/maintenance/$ref': typeof MaintenanceRefRoute
  '/maintenance/new': typeof MaintenanceNewRoute
  '/owners/$ref': typeof OwnersRefRoute
  '/owners/new': typeof OwnersNewRoute
  '/people/$ref': typeof PeopleRefRouteWithChildren
  '/people/new': typeof PeopleNewRoute
  '/people/portal': typeof PeoplePortalRoute
  '/properties/$ref': typeof PropertiesRefRouteWithChildren
  '/properties/listings': typeof PropertiesListingsRoute
  '/properties/map': typeof PropertiesMapRoute
  '/properties/new': typeof PropertiesNewRoute
  '/reconcile/import': typeof ReconcileImportRoute
  '/reconcile/queue': typeof ReconcileQueueRoute
  '/reconcile/suspense': typeof ReconcileSuspenseRoute
  '/reports/audit': typeof ReportsAuditRoute
  '/reports/delivery': typeof ReportsDeliveryRoute
  '/reports/events': typeof ReportsEventsRoute
  '/reports/healthy-homes': typeof ReportsHealthyHomesRoute
  '/reports/matching': typeof ReportsMatchingRoute
  '/reports/reconciliation': typeof ReportsReconciliationRoute
  '/reports/refunds': typeof ReportsRefundsRoute
  '/reports/statements': typeof ReportsStatementsRoute
  '/reports/tax': typeof ReportsTaxRoute
  '/settings/branding': typeof SettingsBrandingRoute
  '/settings/delivery': typeof SettingsDeliveryRoute
  '/settings/import': typeof SettingsImportRoute
  '/settings/inspections': typeof SettingsInspectionsRoute
  '/settings/opening-balances': typeof SettingsOpeningBalancesRoute
  '/settings/parallel-run': typeof SettingsParallelRunRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/statements': typeof SettingsStatementsRoute
  '/settings/tax': typeof SettingsTaxRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/unit-costs': typeof SettingsUnitCostsRoute
  '/settings/users': typeof SettingsUsersRoute
  '/tenancies/$ref': typeof TenanciesRefRoute
  '/tenancies/arrears': typeof TenanciesArrearsRoute
  '/tenancies/bonds': typeof TenanciesBondsRoute
  '/tenancies/new': typeof TenanciesNewRoute
  '/tenancies/rent-reviews': typeof TenanciesRentReviewsRoute
  '/automations/': typeof AutomationsIndexRoute
  '/bills/': typeof BillsIndexRoute
  '/communications/': typeof CommunicationsIndexRoute
  '/contractors/': typeof ContractorsIndexRoute
  '/financial/': typeof FinancialIndexRoute
  '/maintenance/': typeof MaintenanceIndexRoute
  '/owners/': typeof OwnersIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/properties/': typeof PropertiesIndexRoute
  '/reconcile/': typeof ReconcileIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tenancies/': typeof TenanciesIndexRoute
  '/bills/invoices/$ref': typeof BillsInvoicesRefRoute
  '/bills/invoices/new': typeof BillsInvoicesNewRoute
  '/communications/inbox/$id': typeof CommunicationsInboxIdRoute
  '/communications/lists/$id': typeof CommunicationsListsIdRoute
  '/communications/lists/new': typeof CommunicationsListsNewRoute
  '/communications/sends/$id': typeof CommunicationsSendsIdRoute
  '/financial/disbursements/$ref': typeof FinancialDisbursementsRefRoute
  '/financial/invoices/$ref': typeof FinancialInvoicesRefRoute
  '/financial/invoices/new': typeof FinancialInvoicesNewRoute
  '/maintenance/contractors/$ref': typeof MaintenanceContractorsRefRoute
  '/maintenance/contractors/new': typeof MaintenanceContractorsNewRoute
  '/people/$ref/edit': typeof PeopleRefEditRoute
  '/properties/$ref/edit': typeof PropertiesRefEditRoute
  '/properties/inspections/$ref': typeof PropertiesInspectionsRefRoute
  '/settings/organisations/new': typeof SettingsOrganisationsNewRoute
  '/bills/invoices/': typeof BillsInvoicesIndexRoute
  '/communications/inbox/': typeof CommunicationsInboxIndexRoute
  '/communications/sends/': typeof CommunicationsSendsIndexRoute
  '/financial/disbursements/': typeof FinancialDisbursementsIndexRoute
  '/financial/invoices/': typeof FinancialInvoicesIndexRoute
  '/maintenance/contractors/': typeof MaintenanceContractorsIndexRoute
  '/people/$ref/': typeof PeopleRefIndexRoute
  '/properties/$ref/': typeof PropertiesRefIndexRoute
  '/properties/inspections/': typeof PropertiesInspectionsIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/settings/organisations/': typeof SettingsOrganisationsIndexRoute
  '/settings/integrations/tenancy-services/callback': typeof SettingsIntegrationsTenancyServicesCallbackRoute
  '/settings/integrations/trademe/callback': typeof SettingsIntegrationsTrademeCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy'
    | '/set-password'
    | '/terms'
    | '/login'
    | '/mfa'
    | '/signup'
    | '/automations/$id'
    | '/automations/new'
    | '/bills/$ref'
    | '/bills/new'
    | '/contractors/$ref'
    | '/dashboard/custom'
    | '/dashboard/management'
    | '/financial/commission'
    | '/financial/entry'
    | '/financial/new'
    | '/financial/transactions'
    | '/maintenance/$ref'
    | '/maintenance/new'
    | '/owners/$ref'
    | '/owners/new'
    | '/people/$ref'
    | '/people/new'
    | '/people/portal'
    | '/properties/$ref'
    | '/properties/listings'
    | '/properties/map'
    | '/properties/new'
    | '/reconcile/import'
    | '/reconcile/queue'
    | '/reconcile/suspense'
    | '/reports/audit'
    | '/reports/delivery'
    | '/reports/events'
    | '/reports/healthy-homes'
    | '/reports/matching'
    | '/reports/reconciliation'
    | '/reports/refunds'
    | '/reports/statements'
    | '/reports/tax'
    | '/settings/branding'
    | '/settings/delivery'
    | '/settings/import'
    | '/settings/inspections'
    | '/settings/opening-balances'
    | '/settings/parallel-run'
    | '/settings/payments'
    | '/settings/statements'
    | '/settings/tax'
    | '/settings/templates'
    | '/settings/unit-costs'
    | '/settings/users'
    | '/tenancies/$ref'
    | '/tenancies/arrears'
    | '/tenancies/bonds'
    | '/tenancies/new'
    | '/tenancies/rent-reviews'
    | '/automations/'
    | '/bills/'
    | '/communications/'
    | '/contractors/'
    | '/financial/'
    | '/maintenance/'
    | '/owners/'
    | '/people/'
    | '/properties/'
    | '/reconcile/'
    | '/reports/'
    | '/settings/'
    | '/tenancies/'
    | '/bills/invoices/$ref'
    | '/bills/invoices/new'
    | '/communications/inbox/$id'
    | '/communications/lists/$id'
    | '/communications/lists/new'
    | '/communications/sends/$id'
    | '/financial/disbursements/$ref'
    | '/financial/invoices/$ref'
    | '/financial/invoices/new'
    | '/maintenance/contractors/$ref'
    | '/maintenance/contractors/new'
    | '/people/$ref/edit'
    | '/properties/$ref/edit'
    | '/properties/inspections/$ref'
    | '/settings/organisations/new'
    | '/bills/invoices/'
    | '/communications/inbox/'
    | '/communications/sends/'
    | '/financial/disbursements/'
    | '/financial/invoices/'
    | '/maintenance/contractors/'
    | '/people/$ref/'
    | '/properties/$ref/'
    | '/properties/inspections/'
    | '/settings/integrations/'
    | '/settings/organisations/'
    | '/settings/integrations/tenancy-services/callback'
    | '/settings/integrations/trademe/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy'
    | '/set-password'
    | '/terms'
    | '/login'
    | '/mfa'
    | '/signup'
    | '/automations/$id'
    | '/automations/new'
    | '/bills/$ref'
    | '/bills/new'
    | '/contractors/$ref'
    | '/dashboard/custom'
    | '/dashboard/management'
    | '/financial/commission'
    | '/financial/entry'
    | '/financial/new'
    | '/financial/transactions'
    | '/maintenance/$ref'
    | '/maintenance/new'
    | '/owners/$ref'
    | '/owners/new'
    | '/people/new'
    | '/people/portal'
    | '/properties/listings'
    | '/properties/map'
    | '/properties/new'
    | '/reconcile/import'
    | '/reconcile/queue'
    | '/reconcile/suspense'
    | '/reports/audit'
    | '/reports/delivery'
    | '/reports/events'
    | '/reports/healthy-homes'
    | '/reports/matching'
    | '/reports/reconciliation'
    | '/reports/refunds'
    | '/reports/statements'
    | '/reports/tax'
    | '/settings/branding'
    | '/settings/delivery'
    | '/settings/import'
    | '/settings/inspections'
    | '/settings/opening-balances'
    | '/settings/parallel-run'
    | '/settings/payments'
    | '/settings/statements'
    | '/settings/tax'
    | '/settings/templates'
    | '/settings/unit-costs'
    | '/settings/users'
    | '/tenancies/$ref'
    | '/tenancies/arrears'
    | '/tenancies/bonds'
    | '/tenancies/new'
    | '/tenancies/rent-reviews'
    | '/automations'
    | '/bills'
    | '/communications'
    | '/contractors'
    | '/financial'
    | '/maintenance'
    | '/owners'
    | '/people'
    | '/properties'
    | '/reconcile'
    | '/reports'
    | '/settings'
    | '/tenancies'
    | '/bills/invoices/$ref'
    | '/bills/invoices/new'
    | '/communications/inbox/$id'
    | '/communications/lists/$id'
    | '/communications/lists/new'
    | '/communications/sends/$id'
    | '/financial/disbursements/$ref'
    | '/financial/invoices/$ref'
    | '/financial/invoices/new'
    | '/maintenance/contractors/$ref'
    | '/maintenance/contractors/new'
    | '/people/$ref/edit'
    | '/properties/$ref/edit'
    | '/properties/inspections/$ref'
    | '/settings/organisations/new'
    | '/bills/invoices'
    | '/communications/inbox'
    | '/communications/sends'
    | '/financial/disbursements'
    | '/financial/invoices'
    | '/maintenance/contractors'
    | '/people/$ref'
    | '/properties/$ref'
    | '/properties/inspections'
    | '/settings/integrations'
    | '/settings/organisations'
    | '/settings/integrations/tenancy-services/callback'
    | '/settings/integrations/trademe/callback'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/privacy'
    | '/set-password'
    | '/terms'
    | '/_auth/login'
    | '/_auth/mfa'
    | '/_auth/signup'
    | '/automations/$id'
    | '/automations/new'
    | '/bills/$ref'
    | '/bills/new'
    | '/contractors/$ref'
    | '/dashboard/custom'
    | '/dashboard/management'
    | '/financial/commission'
    | '/financial/entry'
    | '/financial/new'
    | '/financial/transactions'
    | '/maintenance/$ref'
    | '/maintenance/new'
    | '/owners/$ref'
    | '/owners/new'
    | '/people/$ref'
    | '/people/new'
    | '/people/portal'
    | '/properties/$ref'
    | '/properties/listings'
    | '/properties/map'
    | '/properties/new'
    | '/reconcile/import'
    | '/reconcile/queue'
    | '/reconcile/suspense'
    | '/reports/audit'
    | '/reports/delivery'
    | '/reports/events'
    | '/reports/healthy-homes'
    | '/reports/matching'
    | '/reports/reconciliation'
    | '/reports/refunds'
    | '/reports/statements'
    | '/reports/tax'
    | '/settings/branding'
    | '/settings/delivery'
    | '/settings/import'
    | '/settings/inspections'
    | '/settings/opening-balances'
    | '/settings/parallel-run'
    | '/settings/payments'
    | '/settings/statements'
    | '/settings/tax'
    | '/settings/templates'
    | '/settings/unit-costs'
    | '/settings/users'
    | '/tenancies/$ref'
    | '/tenancies/arrears'
    | '/tenancies/bonds'
    | '/tenancies/new'
    | '/tenancies/rent-reviews'
    | '/automations/'
    | '/bills/'
    | '/communications/'
    | '/contractors/'
    | '/financial/'
    | '/maintenance/'
    | '/owners/'
    | '/people/'
    | '/properties/'
    | '/reconcile/'
    | '/reports/'
    | '/settings/'
    | '/tenancies/'
    | '/bills/invoices/$ref'
    | '/bills/invoices/new'
    | '/communications/inbox/$id'
    | '/communications/lists/$id'
    | '/communications/lists/new'
    | '/communications/sends/$id'
    | '/financial/disbursements/$ref'
    | '/financial/invoices/$ref'
    | '/financial/invoices/new'
    | '/maintenance/contractors/$ref'
    | '/maintenance/contractors/new'
    | '/people/$ref/edit'
    | '/properties/$ref/edit'
    | '/properties/inspections/$ref'
    | '/settings/organisations/new'
    | '/bills/invoices/'
    | '/communications/inbox/'
    | '/communications/sends/'
    | '/financial/disbursements/'
    | '/financial/invoices/'
    | '/maintenance/contractors/'
    | '/people/$ref/'
    | '/properties/$ref/'
    | '/properties/inspections/'
    | '/settings/integrations/'
    | '/settings/organisations/'
    | '/settings/integrations/tenancy-services/callback'
    | '/settings/integrations/trademe/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  SetPasswordRoute: typeof SetPasswordRoute
  TermsRoute: typeof TermsRoute
  AutomationsIdRoute: typeof AutomationsIdRoute
  AutomationsNewRoute: typeof AutomationsNewRoute
  BillsRefRoute: typeof BillsRefRoute
  BillsNewRoute: typeof BillsNewRoute
  ContractorsRefRoute: typeof ContractorsRefRoute
  DashboardCustomRoute: typeof DashboardCustomRoute
  DashboardManagementRoute: typeof DashboardManagementRoute
  FinancialCommissionRoute: typeof FinancialCommissionRoute
  FinancialEntryRoute: typeof FinancialEntryRoute
  FinancialNewRoute: typeof FinancialNewRoute
  FinancialTransactionsRoute: typeof FinancialTransactionsRoute
  MaintenanceRefRoute: typeof MaintenanceRefRoute
  MaintenanceNewRoute: typeof MaintenanceNewRoute
  OwnersRefRoute: typeof OwnersRefRoute
  OwnersNewRoute: typeof OwnersNewRoute
  PeopleRefRoute: typeof PeopleRefRouteWithChildren
  PeopleNewRoute: typeof PeopleNewRoute
  PeoplePortalRoute: typeof PeoplePortalRoute
  PropertiesRefRoute: typeof PropertiesRefRouteWithChildren
  PropertiesListingsRoute: typeof PropertiesListingsRoute
  PropertiesMapRoute: typeof PropertiesMapRoute
  PropertiesNewRoute: typeof PropertiesNewRoute
  ReconcileImportRoute: typeof ReconcileImportRoute
  ReconcileQueueRoute: typeof ReconcileQueueRoute
  ReconcileSuspenseRoute: typeof ReconcileSuspenseRoute
  ReportsAuditRoute: typeof ReportsAuditRoute
  ReportsDeliveryRoute: typeof ReportsDeliveryRoute
  ReportsEventsRoute: typeof ReportsEventsRoute
  ReportsHealthyHomesRoute: typeof ReportsHealthyHomesRoute
  ReportsMatchingRoute: typeof ReportsMatchingRoute
  ReportsReconciliationRoute: typeof ReportsReconciliationRoute
  ReportsRefundsRoute: typeof ReportsRefundsRoute
  ReportsStatementsRoute: typeof ReportsStatementsRoute
  ReportsTaxRoute: typeof ReportsTaxRoute
  SettingsBrandingRoute: typeof SettingsBrandingRoute
  SettingsDeliveryRoute: typeof SettingsDeliveryRoute
  SettingsImportRoute: typeof SettingsImportRoute
  SettingsInspectionsRoute: typeof SettingsInspectionsRoute
  SettingsOpeningBalancesRoute: typeof SettingsOpeningBalancesRoute
  SettingsParallelRunRoute: typeof SettingsParallelRunRoute
  SettingsPaymentsRoute: typeof SettingsPaymentsRoute
  SettingsStatementsRoute: typeof SettingsStatementsRoute
  SettingsTaxRoute: typeof SettingsTaxRoute
  SettingsTemplatesRoute: typeof SettingsTemplatesRoute
  SettingsUnitCostsRoute: typeof SettingsUnitCostsRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  TenanciesRefRoute: typeof TenanciesRefRoute
  TenanciesArrearsRoute: typeof TenanciesArrearsRoute
  TenanciesBondsRoute: typeof TenanciesBondsRoute
  TenanciesNewRoute: typeof TenanciesNewRoute
  TenanciesRentReviewsRoute: typeof TenanciesRentReviewsRoute
  AutomationsIndexRoute: typeof AutomationsIndexRoute
  BillsIndexRoute: typeof BillsIndexRoute
  CommunicationsIndexRoute: typeof CommunicationsIndexRoute
  ContractorsIndexRoute: typeof ContractorsIndexRoute
  FinancialIndexRoute: typeof FinancialIndexRoute
  MaintenanceIndexRoute: typeof MaintenanceIndexRoute
  OwnersIndexRoute: typeof OwnersIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  PropertiesIndexRoute: typeof PropertiesIndexRoute
  ReconcileIndexRoute: typeof ReconcileIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TenanciesIndexRoute: typeof TenanciesIndexRoute
  BillsInvoicesRefRoute: typeof BillsInvoicesRefRoute
  BillsInvoicesNewRoute: typeof BillsInvoicesNewRoute
  CommunicationsInboxIdRoute: typeof CommunicationsInboxIdRoute
  CommunicationsListsIdRoute: typeof CommunicationsListsIdRoute
  CommunicationsListsNewRoute: typeof CommunicationsListsNewRoute
  CommunicationsSendsIdRoute: typeof CommunicationsSendsIdRoute
  FinancialDisbursementsRefRoute: typeof FinancialDisbursementsRefRoute
  FinancialInvoicesRefRoute: typeof FinancialInvoicesRefRoute
  FinancialInvoicesNewRoute: typeof FinancialInvoicesNewRoute
  MaintenanceContractorsRefRoute: typeof MaintenanceContractorsRefRoute
  MaintenanceContractorsNewRoute: typeof MaintenanceContractorsNewRoute
  PropertiesInspectionsRefRoute: typeof PropertiesInspectionsRefRoute
  SettingsOrganisationsNewRoute: typeof SettingsOrganisationsNewRoute
  BillsInvoicesIndexRoute: typeof BillsInvoicesIndexRoute
  CommunicationsInboxIndexRoute: typeof CommunicationsInboxIndexRoute
  CommunicationsSendsIndexRoute: typeof CommunicationsSendsIndexRoute
  FinancialDisbursementsIndexRoute: typeof FinancialDisbursementsIndexRoute
  FinancialInvoicesIndexRoute: typeof FinancialInvoicesIndexRoute
  MaintenanceContractorsIndexRoute: typeof MaintenanceContractorsIndexRoute
  PropertiesInspectionsIndexRoute: typeof PropertiesInspectionsIndexRoute
  SettingsIntegrationsIndexRoute: typeof SettingsIntegrationsIndexRoute
  SettingsOrganisationsIndexRoute: typeof SettingsOrganisationsIndexRoute
  SettingsIntegrationsTenancyServicesCallbackRoute: typeof SettingsIntegrationsTenancyServicesCallbackRoute
  SettingsIntegrationsTrademeCallbackRoute: typeof SettingsIntegrationsTrademeCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mfa': {
      id: '/_auth/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof AuthMfaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/automations/': {
      id: '/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/$id': {
      id: '/automations/$id'
      path: '/automations/$id'
      fullPath: '/automations/$id'
      preLoaderRoute: typeof AutomationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/new': {
      id: '/automations/new'
      path: '/automations/new'
      fullPath: '/automations/new'
      preLoaderRoute: typeof AutomationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/': {
      id: '/bills/'
      path: '/bills'
      fullPath: '/bills/'
      preLoaderRoute: typeof BillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/$ref': {
      id: '/bills/$ref'
      path: '/bills/$ref'
      fullPath: '/bills/$ref'
      preLoaderRoute: typeof BillsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/new': {
      id: '/bills/new'
      path: '/bills/new'
      fullPath: '/bills/new'
      preLoaderRoute: typeof BillsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/': {
      id: '/communications/'
      path: '/communications'
      fullPath: '/communications/'
      preLoaderRoute: typeof CommunicationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors/': {
      id: '/contractors/'
      path: '/contractors'
      fullPath: '/contractors/'
      preLoaderRoute: typeof ContractorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contractors/$ref': {
      id: '/contractors/$ref'
      path: '/contractors/$ref'
      fullPath: '/contractors/$ref'
      preLoaderRoute: typeof ContractorsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/custom': {
      id: '/dashboard/custom'
      path: '/dashboard/custom'
      fullPath: '/dashboard/custom'
      preLoaderRoute: typeof DashboardCustomRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/management': {
      id: '/dashboard/management'
      path: '/dashboard/management'
      fullPath: '/dashboard/management'
      preLoaderRoute: typeof DashboardManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/': {
      id: '/financial/'
      path: '/financial'
      fullPath: '/financial/'
      preLoaderRoute: typeof FinancialIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/commission': {
      id: '/financial/commission'
      path: '/financial/commission'
      fullPath: '/financial/commission'
      preLoaderRoute: typeof FinancialCommissionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/entry': {
      id: '/financial/entry'
      path: '/financial/entry'
      fullPath: '/financial/entry'
      preLoaderRoute: typeof FinancialEntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/new': {
      id: '/financial/new'
      path: '/financial/new'
      fullPath: '/financial/new'
      preLoaderRoute: typeof FinancialNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/transactions': {
      id: '/financial/transactions'
      path: '/financial/transactions'
      fullPath: '/financial/transactions'
      preLoaderRoute: typeof FinancialTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/': {
      id: '/maintenance/'
      path: '/maintenance'
      fullPath: '/maintenance/'
      preLoaderRoute: typeof MaintenanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/$ref': {
      id: '/maintenance/$ref'
      path: '/maintenance/$ref'
      fullPath: '/maintenance/$ref'
      preLoaderRoute: typeof MaintenanceRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/new': {
      id: '/maintenance/new'
      path: '/maintenance/new'
      fullPath: '/maintenance/new'
      preLoaderRoute: typeof MaintenanceNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owners/': {
      id: '/owners/'
      path: '/owners'
      fullPath: '/owners/'
      preLoaderRoute: typeof OwnersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owners/$ref': {
      id: '/owners/$ref'
      path: '/owners/$ref'
      fullPath: '/owners/$ref'
      preLoaderRoute: typeof OwnersRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owners/new': {
      id: '/owners/new'
      path: '/owners/new'
      fullPath: '/owners/new'
      preLoaderRoute: typeof OwnersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$ref': {
      id: '/people/$ref'
      path: '/people/$ref'
      fullPath: '/people/$ref'
      preLoaderRoute: typeof PeopleRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/new': {
      id: '/people/new'
      path: '/people/new'
      fullPath: '/people/new'
      preLoaderRoute: typeof PeopleNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/portal': {
      id: '/people/portal'
      path: '/people/portal'
      fullPath: '/people/portal'
      preLoaderRoute: typeof PeoplePortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/': {
      id: '/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof PropertiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/$ref': {
      id: '/properties/$ref'
      path: '/properties/$ref'
      fullPath: '/properties/$ref'
      preLoaderRoute: typeof PropertiesRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/listings': {
      id: '/properties/listings'
      path: '/properties/listings'
      fullPath: '/properties/listings'
      preLoaderRoute: typeof PropertiesListingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/map': {
      id: '/properties/map'
      path: '/properties/map'
      fullPath: '/properties/map'
      preLoaderRoute: typeof PropertiesMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/new': {
      id: '/properties/new'
      path: '/properties/new'
      fullPath: '/properties/new'
      preLoaderRoute: typeof PropertiesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile/': {
      id: '/reconcile/'
      path: '/reconcile'
      fullPath: '/reconcile/'
      preLoaderRoute: typeof ReconcileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile/import': {
      id: '/reconcile/import'
      path: '/reconcile/import'
      fullPath: '/reconcile/import'
      preLoaderRoute: typeof ReconcileImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile/queue': {
      id: '/reconcile/queue'
      path: '/reconcile/queue'
      fullPath: '/reconcile/queue'
      preLoaderRoute: typeof ReconcileQueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconcile/suspense': {
      id: '/reconcile/suspense'
      path: '/reconcile/suspense'
      fullPath: '/reconcile/suspense'
      preLoaderRoute: typeof ReconcileSuspenseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/audit': {
      id: '/reports/audit'
      path: '/reports/audit'
      fullPath: '/reports/audit'
      preLoaderRoute: typeof ReportsAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/delivery': {
      id: '/reports/delivery'
      path: '/reports/delivery'
      fullPath: '/reports/delivery'
      preLoaderRoute: typeof ReportsDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/events': {
      id: '/reports/events'
      path: '/reports/events'
      fullPath: '/reports/events'
      preLoaderRoute: typeof ReportsEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/healthy-homes': {
      id: '/reports/healthy-homes'
      path: '/reports/healthy-homes'
      fullPath: '/reports/healthy-homes'
      preLoaderRoute: typeof ReportsHealthyHomesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/matching': {
      id: '/reports/matching'
      path: '/reports/matching'
      fullPath: '/reports/matching'
      preLoaderRoute: typeof ReportsMatchingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/reconciliation': {
      id: '/reports/reconciliation'
      path: '/reports/reconciliation'
      fullPath: '/reports/reconciliation'
      preLoaderRoute: typeof ReportsReconciliationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/refunds': {
      id: '/reports/refunds'
      path: '/reports/refunds'
      fullPath: '/reports/refunds'
      preLoaderRoute: typeof ReportsRefundsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/statements': {
      id: '/reports/statements'
      path: '/reports/statements'
      fullPath: '/reports/statements'
      preLoaderRoute: typeof ReportsStatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/tax': {
      id: '/reports/tax'
      path: '/reports/tax'
      fullPath: '/reports/tax'
      preLoaderRoute: typeof ReportsTaxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/branding': {
      id: '/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof SettingsBrandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/delivery': {
      id: '/settings/delivery'
      path: '/settings/delivery'
      fullPath: '/settings/delivery'
      preLoaderRoute: typeof SettingsDeliveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/import': {
      id: '/settings/import'
      path: '/settings/import'
      fullPath: '/settings/import'
      preLoaderRoute: typeof SettingsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/inspections': {
      id: '/settings/inspections'
      path: '/settings/inspections'
      fullPath: '/settings/inspections'
      preLoaderRoute: typeof SettingsInspectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/opening-balances': {
      id: '/settings/opening-balances'
      path: '/settings/opening-balances'
      fullPath: '/settings/opening-balances'
      preLoaderRoute: typeof SettingsOpeningBalancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/parallel-run': {
      id: '/settings/parallel-run'
      path: '/settings/parallel-run'
      fullPath: '/settings/parallel-run'
      preLoaderRoute: typeof SettingsParallelRunRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payments': {
      id: '/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof SettingsPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/statements': {
      id: '/settings/statements'
      path: '/settings/statements'
      fullPath: '/settings/statements'
      preLoaderRoute: typeof SettingsStatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/tax': {
      id: '/settings/tax'
      path: '/settings/tax'
      fullPath: '/settings/tax'
      preLoaderRoute: typeof SettingsTaxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/templates': {
      id: '/settings/templates'
      path: '/settings/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof SettingsTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/unit-costs': {
      id: '/settings/unit-costs'
      path: '/settings/unit-costs'
      fullPath: '/settings/unit-costs'
      preLoaderRoute: typeof SettingsUnitCostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/': {
      id: '/tenancies/'
      path: '/tenancies'
      fullPath: '/tenancies/'
      preLoaderRoute: typeof TenanciesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/$ref': {
      id: '/tenancies/$ref'
      path: '/tenancies/$ref'
      fullPath: '/tenancies/$ref'
      preLoaderRoute: typeof TenanciesRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/arrears': {
      id: '/tenancies/arrears'
      path: '/tenancies/arrears'
      fullPath: '/tenancies/arrears'
      preLoaderRoute: typeof TenanciesArrearsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/bonds': {
      id: '/tenancies/bonds'
      path: '/tenancies/bonds'
      fullPath: '/tenancies/bonds'
      preLoaderRoute: typeof TenanciesBondsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/new': {
      id: '/tenancies/new'
      path: '/tenancies/new'
      fullPath: '/tenancies/new'
      preLoaderRoute: typeof TenanciesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenancies/rent-reviews': {
      id: '/tenancies/rent-reviews'
      path: '/tenancies/rent-reviews'
      fullPath: '/tenancies/rent-reviews'
      preLoaderRoute: typeof TenanciesRentReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/invoices/': {
      id: '/bills/invoices/'
      path: '/bills/invoices'
      fullPath: '/bills/invoices/'
      preLoaderRoute: typeof BillsInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/invoices/$ref': {
      id: '/bills/invoices/$ref'
      path: '/bills/invoices/$ref'
      fullPath: '/bills/invoices/$ref'
      preLoaderRoute: typeof BillsInvoicesRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/invoices/new': {
      id: '/bills/invoices/new'
      path: '/bills/invoices/new'
      fullPath: '/bills/invoices/new'
      preLoaderRoute: typeof BillsInvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/inbox/': {
      id: '/communications/inbox/'
      path: '/communications/inbox'
      fullPath: '/communications/inbox/'
      preLoaderRoute: typeof CommunicationsInboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/inbox/$id': {
      id: '/communications/inbox/$id'
      path: '/communications/inbox/$id'
      fullPath: '/communications/inbox/$id'
      preLoaderRoute: typeof CommunicationsInboxIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/lists/$id': {
      id: '/communications/lists/$id'
      path: '/communications/lists/$id'
      fullPath: '/communications/lists/$id'
      preLoaderRoute: typeof CommunicationsListsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/lists/new': {
      id: '/communications/lists/new'
      path: '/communications/lists/new'
      fullPath: '/communications/lists/new'
      preLoaderRoute: typeof CommunicationsListsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/sends/': {
      id: '/communications/sends/'
      path: '/communications/sends'
      fullPath: '/communications/sends/'
      preLoaderRoute: typeof CommunicationsSendsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/sends/$id': {
      id: '/communications/sends/$id'
      path: '/communications/sends/$id'
      fullPath: '/communications/sends/$id'
      preLoaderRoute: typeof CommunicationsSendsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/disbursements/': {
      id: '/financial/disbursements/'
      path: '/financial/disbursements'
      fullPath: '/financial/disbursements/'
      preLoaderRoute: typeof FinancialDisbursementsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/disbursements/$ref': {
      id: '/financial/disbursements/$ref'
      path: '/financial/disbursements/$ref'
      fullPath: '/financial/disbursements/$ref'
      preLoaderRoute: typeof FinancialDisbursementsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/invoices/': {
      id: '/financial/invoices/'
      path: '/financial/invoices'
      fullPath: '/financial/invoices/'
      preLoaderRoute: typeof FinancialInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/invoices/$ref': {
      id: '/financial/invoices/$ref'
      path: '/financial/invoices/$ref'
      fullPath: '/financial/invoices/$ref'
      preLoaderRoute: typeof FinancialInvoicesRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/financial/invoices/new': {
      id: '/financial/invoices/new'
      path: '/financial/invoices/new'
      fullPath: '/financial/invoices/new'
      preLoaderRoute: typeof FinancialInvoicesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/contractors/': {
      id: '/maintenance/contractors/'
      path: '/maintenance/contractors'
      fullPath: '/maintenance/contractors/'
      preLoaderRoute: typeof MaintenanceContractorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/contractors/$ref': {
      id: '/maintenance/contractors/$ref'
      path: '/maintenance/contractors/$ref'
      fullPath: '/maintenance/contractors/$ref'
      preLoaderRoute: typeof MaintenanceContractorsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance/contractors/new': {
      id: '/maintenance/contractors/new'
      path: '/maintenance/contractors/new'
      fullPath: '/maintenance/contractors/new'
      preLoaderRoute: typeof MaintenanceContractorsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$ref/': {
      id: '/people/$ref/'
      path: '/'
      fullPath: '/people/$ref/'
      preLoaderRoute: typeof PeopleRefIndexRouteImport
      parentRoute: typeof PeopleRefRoute
    }
    '/people/$ref/edit': {
      id: '/people/$ref/edit'
      path: '/edit'
      fullPath: '/people/$ref/edit'
      preLoaderRoute: typeof PeopleRefEditRouteImport
      parentRoute: typeof PeopleRefRoute
    }
    '/properties/$ref/': {
      id: '/properties/$ref/'
      path: '/'
      fullPath: '/properties/$ref/'
      preLoaderRoute: typeof PropertiesRefIndexRouteImport
      parentRoute: typeof PropertiesRefRoute
    }
    '/properties/$ref/edit': {
      id: '/properties/$ref/edit'
      path: '/edit'
      fullPath: '/properties/$ref/edit'
      preLoaderRoute: typeof PropertiesRefEditRouteImport
      parentRoute: typeof PropertiesRefRoute
    }
    '/properties/inspections/': {
      id: '/properties/inspections/'
      path: '/properties/inspections'
      fullPath: '/properties/inspections/'
      preLoaderRoute: typeof PropertiesInspectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/properties/inspections/$ref': {
      id: '/properties/inspections/$ref'
      path: '/properties/inspections/$ref'
      fullPath: '/properties/inspections/$ref'
      preLoaderRoute: typeof PropertiesInspectionsRefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/': {
      id: '/settings/integrations/'
      path: '/settings/integrations'
      fullPath: '/settings/integrations/'
      preLoaderRoute: typeof SettingsIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organisations/': {
      id: '/settings/organisations/'
      path: '/settings/organisations'
      fullPath: '/settings/organisations/'
      preLoaderRoute: typeof SettingsOrganisationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/organisations/new': {
      id: '/settings/organisations/new'
      path: '/settings/organisations/new'
      fullPath: '/settings/organisations/new'
      preLoaderRoute: typeof SettingsOrganisationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/tenancy-services/callback': {
      id: '/settings/integrations/tenancy-services/callback'
      path: '/settings/integrations/tenancy-services/callback'
      fullPath: '/settings/integrations/tenancy-services/callback'
      preLoaderRoute: typeof SettingsIntegrationsTenancyServicesCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/trademe/callback': {
      id: '/settings/integrations/trademe/callback'
      path: '/settings/integrations/trademe/callback'
      fullPath: '/settings/integrations/trademe/callback'
      preLoaderRoute: typeof SettingsIntegrationsTrademeCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMfaRoute: typeof AuthMfaRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthMfaRoute: AuthMfaRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PeopleRefRouteChildren {
  PeopleRefEditRoute: typeof PeopleRefEditRoute
  PeopleRefIndexRoute: typeof PeopleRefIndexRoute
}

const PeopleRefRouteChildren: PeopleRefRouteChildren = {
  PeopleRefEditRoute: PeopleRefEditRoute,
  PeopleRefIndexRoute: PeopleRefIndexRoute,
}

const PeopleRefRouteWithChildren = PeopleRefRoute._addFileChildren(
  PeopleRefRouteChildren,
)

interface PropertiesRefRouteChildren {
  PropertiesRefEditRoute: typeof PropertiesRefEditRoute
  PropertiesRefIndexRoute: typeof PropertiesRefIndexRoute
}

const PropertiesRefRouteChildren: PropertiesRefRouteChildren = {
  PropertiesRefEditRoute: PropertiesRefEditRoute,
  PropertiesRefIndexRoute: PropertiesRefIndexRoute,
}

const PropertiesRefRouteWithChildren = PropertiesRefRoute._addFileChildren(
  PropertiesRefRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  SetPasswordRoute: SetPasswordRoute,
  TermsRoute: TermsRoute,
  AutomationsIdRoute: AutomationsIdRoute,
  AutomationsNewRoute: AutomationsNewRoute,
  BillsRefRoute: BillsRefRoute,
  BillsNewRoute: BillsNewRoute,
  ContractorsRefRoute: ContractorsRefRoute,
  DashboardCustomRoute: DashboardCustomRoute,
  DashboardManagementRoute: DashboardManagementRoute,
  FinancialCommissionRoute: FinancialCommissionRoute,
  FinancialEntryRoute: FinancialEntryRoute,
  FinancialNewRoute: FinancialNewRoute,
  FinancialTransactionsRoute: FinancialTransactionsRoute,
  MaintenanceRefRoute: MaintenanceRefRoute,
  MaintenanceNewRoute: MaintenanceNewRoute,
  OwnersRefRoute: OwnersRefRoute,
  OwnersNewRoute: OwnersNewRoute,
  PeopleRefRoute: PeopleRefRouteWithChildren,
  PeopleNewRoute: PeopleNewRoute,
  PeoplePortalRoute: PeoplePortalRoute,
  PropertiesRefRoute: PropertiesRefRouteWithChildren,
  PropertiesListingsRoute: PropertiesListingsRoute,
  PropertiesMapRoute: PropertiesMapRoute,
  PropertiesNewRoute: PropertiesNewRoute,
  ReconcileImportRoute: ReconcileImportRoute,
  ReconcileQueueRoute: ReconcileQueueRoute,
  ReconcileSuspenseRoute: ReconcileSuspenseRoute,
  ReportsAuditRoute: ReportsAuditRoute,
  ReportsDeliveryRoute: ReportsDeliveryRoute,
  ReportsEventsRoute: ReportsEventsRoute,
  ReportsHealthyHomesRoute: ReportsHealthyHomesRoute,
  ReportsMatchingRoute: ReportsMatchingRoute,
  ReportsReconciliationRoute: ReportsReconciliationRoute,
  ReportsRefundsRoute: ReportsRefundsRoute,
  ReportsStatementsRoute: ReportsStatementsRoute,
  ReportsTaxRoute: ReportsTaxRoute,
  SettingsBrandingRoute: SettingsBrandingRoute,
  SettingsDeliveryRoute: SettingsDeliveryRoute,
  SettingsImportRoute: SettingsImportRoute,
  SettingsInspectionsRoute: SettingsInspectionsRoute,
  SettingsOpeningBalancesRoute: SettingsOpeningBalancesRoute,
  SettingsParallelRunRoute: SettingsParallelRunRoute,
  SettingsPaymentsRoute: SettingsPaymentsRoute,
  SettingsStatementsRoute: SettingsStatementsRoute,
  SettingsTaxRoute: SettingsTaxRoute,
  SettingsTemplatesRoute: SettingsTemplatesRoute,
  SettingsUnitCostsRoute: SettingsUnitCostsRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  TenanciesRefRoute: TenanciesRefRoute,
  TenanciesArrearsRoute: TenanciesArrearsRoute,
  TenanciesBondsRoute: TenanciesBondsRoute,
  TenanciesNewRoute: TenanciesNewRoute,
  TenanciesRentReviewsRoute: TenanciesRentReviewsRoute,
  AutomationsIndexRoute: AutomationsIndexRoute,
  BillsIndexRoute: BillsIndexRoute,
  CommunicationsIndexRoute: CommunicationsIndexRoute,
  ContractorsIndexRoute: ContractorsIndexRoute,
  FinancialIndexRoute: FinancialIndexRoute,
  MaintenanceIndexRoute: MaintenanceIndexRoute,
  OwnersIndexRoute: OwnersIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  PropertiesIndexRoute: PropertiesIndexRoute,
  ReconcileIndexRoute: ReconcileIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TenanciesIndexRoute: TenanciesIndexRoute,
  BillsInvoicesRefRoute: BillsInvoicesRefRoute,
  BillsInvoicesNewRoute: BillsInvoicesNewRoute,
  CommunicationsInboxIdRoute: CommunicationsInboxIdRoute,
  CommunicationsListsIdRoute: CommunicationsListsIdRoute,
  CommunicationsListsNewRoute: CommunicationsListsNewRoute,
  CommunicationsSendsIdRoute: CommunicationsSendsIdRoute,
  FinancialDisbursementsRefRoute: FinancialDisbursementsRefRoute,
  FinancialInvoicesRefRoute: FinancialInvoicesRefRoute,
  FinancialInvoicesNewRoute: FinancialInvoicesNewRoute,
  MaintenanceContractorsRefRoute: MaintenanceContractorsRefRoute,
  MaintenanceContractorsNewRoute: MaintenanceContractorsNewRoute,
  PropertiesInspectionsRefRoute: PropertiesInspectionsRefRoute,
  SettingsOrganisationsNewRoute: SettingsOrganisationsNewRoute,
  BillsInvoicesIndexRoute: BillsInvoicesIndexRoute,
  CommunicationsInboxIndexRoute: CommunicationsInboxIndexRoute,
  CommunicationsSendsIndexRoute: CommunicationsSendsIndexRoute,
  FinancialDisbursementsIndexRoute: FinancialDisbursementsIndexRoute,
  FinancialInvoicesIndexRoute: FinancialInvoicesIndexRoute,
  MaintenanceContractorsIndexRoute: MaintenanceContractorsIndexRoute,
  PropertiesInspectionsIndexRoute: PropertiesInspectionsIndexRoute,
  SettingsIntegrationsIndexRoute: SettingsIntegrationsIndexRoute,
  SettingsOrganisationsIndexRoute: SettingsOrganisationsIndexRoute,
  SettingsIntegrationsTenancyServicesCallbackRoute:
    SettingsIntegrationsTenancyServicesCallbackRoute,
  SettingsIntegrationsTrademeCallbackRoute:
    SettingsIntegrationsTrademeCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
